import React from 'react';
import { useHistory } from "react-router-dom";


const Tarea = ({tarea}) => {

    const history = useHistory();

    const seleccionarCalculo = () => {
        
        history.push(`/proyectos/${tarea.link}`)
    }

    // funcion que modifica el estado de las tareas
    const cambiarEstado = () => {
        if (tarea.estado) {
            tarea.estado = false;
        } else {
            tarea.estado = true;
        }
       // actualizarXtarea(xtarea);
    }

    return (  
        <li className="tarea sombra">
            <p>{tarea.nombre} </p>
            <div className="estado">
                {tarea.estado
                    ? (<button
                        type="button"
                        className="completo"
                        onClick={() => cambiarEstado(tarea)}
                        >Terminado</button>
                    )
                    : (
                        <button
                        type="button"
                        className="incompleto"
                        onClick={() => cambiarEstado(tarea)}
                        >En Proceso</button>
                    )
                }
            </div>
            <div className="acciones">
            <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => seleccionarCalculo()}
                >Calcular</button>
            </div>
        </li>
    );
}
 
export default Tarea;